import { UserModel, UserTypeIds } from "./UserModel";

const { createSlice } = require("@reduxjs/toolkit");

const initialState = { model: UserModel() };

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.model = action.payload;
    },
    resetUser: (state) => {
      state.model = UserModel();
    },
  },
});

export default userSlice.reducer;

export const { setUser, resetUser } = userSlice.actions;

// selectors
export const selectCurrentUser = (state) => state.user.model;
export const selectUserSignedIn = (state) => state.user.model.userTypeId !== UserTypeIds.Default;